import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'bilancio-consolidato';
export const ENTITY_PLURAL = 'Bilancio Consolidato';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Ente',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'ente.descrizione',
  },
  {
    elementLabel: 'Esercizio',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'esercizio',
  },
  {
    elementLabel: 'Risultato di Esercizio CE',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'risultatoEsercizioCE',
    minWidth: 160,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Risultato di Esercizio SPP',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'risultatoEsercizioSPP',
    minWidth: 160,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Totale Attivo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'totaleAttivo',
    minWidth: 160,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Totale Passivo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'totalePassivo',
    minWidth: 160,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Chiuso',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'chiuso',
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
